export default __webpack_public_path__ + "static/media/PromoBannerFanta.353fbaff.png";